import { Injectable } from "@angular/core";
import { NgEnvVarsService } from "../../../../../ng-shared/ng-services/ng-env-vars.service";
import {BaseAppDetailEnvService} from "../../base-app-detail-env.service";

@Injectable()
export class BaseSubmenuHybridConnService {
    constructor(
        private envCtrlSvc: BaseAppDetailEnvService,
        private envVars: NgEnvVarsService) {
    }

    getEnvCtrlService() {
        return this.envCtrlSvc;
    }

    getEnvVarsService() {
        return this.envVars;
    }
}
